import React from 'react';

import { Box, Flex, Typography } from 'components';
import { brazilianRealFormat, createMarkup } from 'app/utils';
import { PaymentsSafeBuyFooter, useOffers } from 'features/offers';

const Sidebar = React.memo(() => {
  const { buyInformation } = useOffers();

  let value = 0;
  let totalValue = 0;
  let installments = 1;

  if (!!buyInformation?.creditCardValues?.length) {
    installments = buyInformation?.creditCardValues?.length;
    value = buyInformation?.creditCardValues[buyInformation?.creditCardValues.length - 1].installmentValue;
    totalValue = buyInformation?.creditCardValues[0].totalValue;
  } else if (!!buyInformation?.boletoValues?.length) {
    installments = buyInformation?.boletoValues?.length;
    value = buyInformation?.boletoValues[buyInformation?.boletoValues.length - 1].installmentValue;
    totalValue = buyInformation?.boletoValues[0].totalValue;
  } else if (!!buyInformation?.pixValues?.length) {
    installments = buyInformation?.pixValues?.length;
    value = buyInformation?.pixValues[buyInformation?.pixValues.length - 1].installmentValue;
    totalValue = buyInformation?.pixValues[0].totalValue;
  }

  return buyInformation ? (
    <Flex flexGrow={0} flexShrink={0} width={{ m: '100%', d: 300 }}>
      <Flex flexDirection="column">
        <Flex
          display={{ m: 'none', d: 'flex' }}
          flexDirection="column"
          bg={{ m: 'gray_100', d: 'white' }}
          borderTopLeftRadius={{ m: 0, d: 4 }}
          borderTopRightRadius={{ m: 0, d: 4 }}
          borderBottomLeftRadius={{ m: 0, d: 0 }}
          borderBottomRightRadius={{ m: 0, d: 0 }}
          p={3}
        >
          {/* <Typography type="type2" color="gray_500" upper mb={1}>
            {buyInformation?.productHat}
          </Typography> */}

          <Typography type="type7" fontWeight="bold" lineHeight={1.1} color="dark_350">
            {buyInformation?.offerName}
          </Typography>

          {!!buyInformation?.offerDescription && (
            <Typography type="type1" lineHeight={1.3} color="gray_500" mt={3}>
              <div dangerouslySetInnerHTML={createMarkup(buyInformation?.offerDescription)} />
            </Typography>
          )}
        </Flex>

        {buyInformation?.freeOffer ? (
          <Flex
            display={{ m: 'none', d: 'flex' }}
            flexDirection="column"
            bg="dark_350"
            borderBottomLeftRadius={{ m: 0, d: 4 }}
            borderBottomRightRadius={{ m: 0, d: 4 }}
            p={3}
          >
            <Typography type="type2" color="gray_500" upper>
              Valor
            </Typography>

            <Typography type="type5" fontWeight="bold" lineHeight={1.1} color="white" mt={1}>
              Gratuito
            </Typography>
          </Flex>
        ) : (
          <Flex
            display={{ m: 'none', d: 'flex' }}
            flexDirection="column"
            bg="dark_350"
            borderBottomLeftRadius={{ m: 0, d: 4 }}
            borderBottomRightRadius={{ m: 0, d: 4 }}
            p={3}
          >
            <Typography type="type2" color="gray_500" upper>
              Valor
            </Typography>

            {installments === 1 ? (
              <>
                <Typography type="type5" fontWeight="bold" lineHeight={1.1} color="white" mt={1}>
                  {brazilianRealFormat(value)}
                </Typography>
              </>
            ) : (
              <>
                <Typography type="type5" fontWeight="bold" lineHeight={1.1} color="white" mt={1}>
                  {installments}x de {brazilianRealFormat(value)}
                </Typography>

                {!buyInformation?.isRecurrence && (
                  <Typography type="type1" lineHeight={1.3} color="gray_500" mt={2}>
                    Ou {brazilianRealFormat(totalValue)} à vista
                  </Typography>
                )}
              </>
            )}
          </Flex>
        )}
      </Flex>

      <Box display={{ m: 'none', d: 'block' }} mt={5}>
        <PaymentsSafeBuyFooter freeOffer={buyInformation?.freeOffer} />
      </Box>
    </Flex>
  ) : (
    <></>
  );
});

export default Sidebar;
